export const PaymentProviders = {
    WALLET: 'WALLET'
};
